import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import QuantityControl from '../helper/QuantityControl';
import { CartContext } from './CartContext';
import './HeaderOne.css';

const CartSection = () => {
    const { cart, removeFromCart } = useContext(CartContext);
    
    // Base URL from environment variables
    // const IMAGE_BASE_URL = process.env.REACT_APP_SERVER;

    const subtotal = cart.reduce((acc, item) => acc + item.quantity * item.sale_price, 0);
    
    const newsubtotal = cart.reduce((acc, item) => {
        const total = item.sale_price - (item.sale_price * item.gst_slab) / 100;
        return acc + item.quantity * total;
    }, 0);

    const newEgst = cart.reduce((acc, item) => {
        const total = (item.sale_price * item.gst_slab) / 100;
        return acc + item.quantity * total;
    }, 0);

    return (
        <>
            <section className="cart py-80">
                <div className="container container-lg">
                    <div className="row gy-4">
                        <div className="col-xl-9 col-lg-8">
                            <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
                                <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                                    <table className="table style-three">
                                        <thead>
                                            <tr className='bg-main-400'>
                                                <th style={{ textAlign: "center" }}>S.No</th>
                                                <th className="cart_product">Product Image</th>
                                                <th style={{ textAlign: "center" }}>Product Name</th>
                                                <th>MRP</th>
                                                <th>Discount</th>
                                                <th>Selling price</th>
                                                <th style={{ textAlign: "center" }}>Qty</th>
                                                <th>Total</th>
                                                <th className="action" style={{ fontSize: "30px" }}>
                                                    <i className="mdi mdi-delete-forever"></i>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cart.length === 0 ? (
                                                <tr>
                                                    <td colSpan="10">
                                                        <p className="text-center">Your cart is empty.</p>
                                                    </td>
                                                </tr>
                                            ) : (
                                                cart?.map((item, index) => {
                                                    const totalExclGst = item.sale_price * Number(item.quantity);

                                                    return (
                                                        <tr key={`${item.product_id}-${item.unit_id}`}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <div className="table-product d-flex align-items-center gap-24">
                                                                    <Link
                                                                        to={`/product-details/${item.product_id}/${item.unit_id}`}
                                                                        className="table-product__thumb border border-gray-100 rounded-8 flex-center"
                                                                    >
<img
    src={
        item.product_img_200 
        ? item.product_img_200 
        : 'https://placehold.co/200x200?text=No+Image'
    }
    alt={item.product_name}
    onError={(e) => { 
        e.target.onerror = null; 
        e.target.src = 'https://placehold.co/200x200?text=Error+Loading'; 
    }}
    style={{ width: '80px', height: '80px', objectFit: 'contain' }}
/>
                                                                    </Link>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="table-product__content text-start">
                                                                    <h6 className="title text-lg fw-semibold mb-8">
                                                                        <Link
                                                                            to={`/product-details/${item.product_id}/${item.unit_id}`}
                                                                            className="link text-line-2"
                                                                        >
                                                                            {item.product_name}
                                                                        </Link>
                                                                    </h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span className="text-lg h6 mb-0 fw-semibold">₹{item.mrp.toFixed(2)}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-lg h6 mb-0 fw-semibold">{item.discount_percentage}%</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-lg h6 mb-0 fw-semibold">₹{item.sale_price.toFixed(2)}</span>
                                                            </td>
                                                            <td className='quanity'>
                                                                <QuantityControl
                                                                    initialQuantity={item.quantity}
                                                                    cartId={item.cart_id}
                                                                    productId={item.product_id}
                                                                    unitId={item.unit_id}
                                                                />
                                                            </td>
                                                            <td>
                                                                ₹{totalExclGst.toFixed(2)}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    title="Remove"
                                                                    onClick={() => removeFromCart(item.cart_id, item.product_id, item.unit_id)}
                                                                >
                                                                    <i className="mdi mdi-close-circle-outline"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4">
                            <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
                                <h6 className="text-xl mb-32">Cart Totals</h6>
                                <div className="bg-color-three rounded-8 p-24">
                                    <div className="mb-32 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two">Subtotal</span>
                                        <span className="text-gray-900 fw-semibold">₹{newsubtotal.toFixed(2)}</span>
                                    </div>
                                    <div className="mb-32 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two">Estimated Delivery</span>
                                        <span className="text-gray-900 fw-semibold">Free</span>
                                    </div>
                                    <div className="mb-0 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two">Estimated Tax</span>
                                        <span className="text-gray-900 fw-semibold">₹{newEgst.toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className="bg-color-three rounded-8 p-24 mt-24">
                                    <div className="flex-between gap-8">
                                        <span className="text-gray-900 text-xl fw-semibold">Total</span>
                                        <span className="text-gray-900 text-xl fw-semibold">₹{(subtotal).toFixed(2)}</span>
                                    </div>
                                </div>
                                {subtotal !== 0 && (
                                    <Link
                                        to="/checkout"
                                        className="btn btn-main mt-40 py-18 w-100 rounded-8"
                                    >
                                        Proceed to checkout
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default CartSection;